import React, { createContext, useState } from "react";
import { generateIACarePlan } from "../../utils/services/Careplans/IACareplans/generateIACarePlan";
import { useValidToken } from "../../hooks/useValidToken";

export const IACarePlanContext = createContext();

export const IACarePlanProvider = ({ children }) => {
  const [resultado, setResultado] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { token, isValid, authLoading } = useValidToken();

  const generatePlan = async (patientData) => {
    console.log("[IACarePlanContext] ▶ generatePlan called");
    console.log("[IACarePlanContext] Auth state → isValid:", isValid, "authLoading:", authLoading, "tokenPresent:", !!token);
    console.log("[IACarePlanContext] patientData:", patientData);

    if (!isValid || authLoading) {
      console.warn("[IACarePlanContext] ⚠ Aborted — token invalid or auth still loading");
      return;
    }

    setLoading(true);
    setError(null);
    setResultado("");

    try {
      console.log("[IACarePlanContext] → calling generateIACarePlan service...");
      const data = await generateIACarePlan(patientData);
      console.log("[IACarePlanContext] ✓ service returned:", data);
      setResultado(data.resultado);
    } catch (err) {
      console.error("[IACarePlanContext] ✗ ERROR caught in generatePlan:", err);
      console.error("[IACarePlanContext] ✗ err.response?.data:", err.response?.data);
      console.error("[IACarePlanContext] ✗ err.response?.status:", err.response?.status);
      setError("Error generando el plan. Intenta nuevamente.");
    } finally {
      console.log("[IACarePlanContext] ◼ generatePlan finished, setLoading(false)");
      setLoading(false);
    }
  };

  return (
    <IACarePlanContext.Provider
      value={{
        resultado,
        loading,
        error,
        generatePlan,
      }}
    >
      {children}
    </IACarePlanContext.Provider>
  );
};
